export default api => ({
    signin: params => api.post('/auth/signin', params),
})
